import { initConstants } from '@/commons/utils/meta.utils';
import { Meta } from '@/metas/meta';

// 婚姻状况
const MARITAL_STATUS: Meta = {
    metaData: {
        YES: [1, '已婚'],
        NO: [0, '未婚'],
    },
    list: [],
    valueEnum: {},
    codeMapping: new Map(),
};

initConstants(MARITAL_STATUS);

export { MARITAL_STATUS };
